<template>
    <Modal v-if="open" mode="singlePayment">
        <h2 class="text-4xl text-center font-hairline md:leading-loose text-grey md:mt-8 mb-4">
            <span v-if="action === 'add'" data-cy="add" >Enter new Payment:</span>
            <span v-else-if="action === 'update'" data-cy="update" >Edit Payment:</span>
        </h2>
        <p class="text-xl leading-normal mb-8 text-center">
            + positive means you get something, <br> - negative means you pay something
        </p>
        <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
                <label class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-date">
                    Date
                </label>
            </div>
            <div class="md:w-2/3">
                <input
                    class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="inline-date"
                    type="date"
                    data-cy="date"
                    :min="today"
                    v-model="payment.date"
                >
            </div>
        </div>
        <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
                <label class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-text">
                    Text
                </label>
            </div>
            <div class="md:w-2/3">
                <input
                    class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="inline-text"
                    type="text"
                    placeholder="Customer A"
                    data-cy="text"
                    v-model="payment.text"
                >
            </div>
        </div>
        <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
                <label class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-amount">
                    Amount
                </label>
            </div>
            <div class="md:w-2/3">
                <input
                    class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="inline-amount"
                    type="number"
                    placeholder="1000"
                    data-cy="amount"
                    v-model.number="payment.amount"
                >
            </div>
        </div>
        <div class="md:flex md:items-center">
            <div class="md:w-1/3"></div>
            <div class="md:w-2/3">
                <button
                    data-cy="buttonSave"
                    :disabled="!canSave"
                    @click="action === 'add' ? addPayment() : updatePayment()"
                    class="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 m-2 rounded" type="button"
                >
                    Save
                </button>
                <button
                    data-cy="buttonSaveExit"
                    :disabled="!canSave"
                    @click="action === 'add' ? addPayment(true) : updatePayment(true);"
                    class="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 m-2 rounded" type="button"
                >
                    Save &amp; Exit
                </button>
            </div>
        </div>
    </Modal>
</template>

<script>
// import { db } from '@/db.js';
import dayjs from 'dayjs';
import { mapFields } from 'vuex-map-fields';
import Modal from '@/components/Modal.vue';

export default {
    name: 'ModalSinglePayment',
    props: {
        'payments-list': Array,
    },
    components: {
        Modal,
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapFields([
            'payment',
            'paymentsRef',
            'toggle.singlePayment.spModal.open',
            'toggle.singlePayment.spModal.action',
            'user.uid',
        ]),
        canSave() {
            // console.log('this.payment.date:', this.payment.date);
            if (!this.payment.amount && this.payment.amount === '') { return false; }
            if (!this.payment.text && this.payment.text === '') { return false; }
            if (!this.payment.date && this.payment.date === '') { return false; }

            return true;
        },
        today() {
            return dayjs().format('YYYY-MM-DD');
        },
    },
    created() {
    },
    methods: {
        addPayment(shouldClose = false) {
            if (this.payment.date.length === 10 && dayjs(this.payment.date).isValid()) {
                // this.payment.amount = timestamp.fromDate(dayjs(this.payment.amount, 'YYYY-MM-DD').toDate());
                // this.payment.createdAt = serverTimestamp();
                this.paymentsRef.collection('list').add(this.payment)
                    .then(() => {
                        this.closeModal(shouldClose);
                    })
                    .catch(() => {
                        // console.error('Error writing document: ', error);
                    });
            }
        },
        updatePayment(shouldClose = false) {
            if (dayjs(this.payment.date).isValid()) {
                // console.log('this.payment.id:', this.payment.id);
                // console.log('this.payment:', this.payment);
                this.paymentsRef.collection('list').doc(this.payment.id).set(this.payment)
                    .then(() => {
                        this.closeModal(shouldClose);
                    })
                    .catch(() => {
                        // console.error('Error writing document: ', error);
                    });
            }
        },
        closeModal(shouldClose) {
            if (shouldClose) {
                this.$store.commit('CLEAR_PAYMENT');
                this.$store.commit('SET_SINGLEPAYMENT_MODAL', false);
            }
        },
    },
};
</script>

<style scoped>
</style>
